<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_4">Persons Represented</a></h2><a id="page_4">
<p class="noindent"><span class="bold">KING EDWARD THE FOURTH</span></p>
<p class="noindent1">Sons to the king</p>
<p class="noindent"><span class="bold">EDWARD, PRINCE OF WALES</span></p>
<p class="noindenti">Afterwards <span class="bold">KING EDWARD V</span></p>
<p class="noindent"><span class="bold">RICHARD, DUKE OF YORK</span></p>
<p class="noindent1">Brothers to the king</p>
<p class="noindent"><span class="bold">GEORGE, DUKE OF CLARENCE</span></p>
<p class="noindent"><span class="bold">RICHARD, DUKE OF GLOSTER,</span></p>
<p class="noindenti">Afterwards <span class="bold">KING RICHARD III</span></p>
<p class="noindent1"><span class="bold">A YOUNG SON OF CLARENCE</span></p>
<p class="noindent">HENRY, EARL OF RICHMOND,</p>
<p class="noindenti">Afterwards <span class="bold">KING HENRY VII</span></p>
<p class="noindent"><span class="bold">CARDINAL BOURCHIER, ARCHBISHOP OF CANTERBURY</span></p>
<p class="noindent"><span class="bold">THOMAS ROTHERHAM, ARCHBISHOP OF YORK</span></p>
<p class="noindent"><span class="bold">JOHN MORTON, BISHOP OF ELY</span></p>
<p class="noindent"><span class="bold">DUKE OF BUCKINGHAM</span></p>
<p class="noindent"><span class="bold">DUKE OF NORFOLK</span></p>
<p class="noindent"><span class="bold">EARL OF SURREY</span>, his son</p>
<p class="noindent"><span class="bold">EARL RIVERS</span>, brother to King Edward’s Queen</p>
<p class="noindent"><span class="bold">MARQUIS OF DORSET</span> and <span class="bold">LORD GREY</span>, her sons</p>
<p class="noindent"><span class="bold">EARL OF OXFORD</span></p>
<p class="noindent"><span class="bold">LORD HASTINGS</span></p>
</a><p class="noindent"><a id="page_4"><span class="bold"></span></a><a id="page_5">LORD STANLEY</a></p><a id="page_5">
<p class="noindent"><span class="bold">LORD LOVEL</span></p>
<p class="noindent"><span class="bold">SIR THOMAS VAUGHAN</span></p>
<p class="noindent"><span class="bold">SIR RICHARD RATCLIFF</span></p>
<p class="noindent"><span class="bold">SIR WILLIAM CATESBY</span></p>
<p class="noindent"><span class="bold">SIR JAMES TYRREL</span></p>
<p class="noindent"><span class="bold">SIR JAMES BLOUNT</span></p>
<p class="noindent"><span class="bold">SIR WALTER HERBERT</span></p>
<p class="noindent"><span class="bold">SIR ROBERT BRAKENBURY</span>, Lieutenant of the Tower</p>
<p class="noindent"><span class="bold">CHRISTOPHER URSWICK</span>, a priest</p>
<p class="noindent">Another Priest</p>
<p class="noindent"><span class="bold">LORD MAYOR OF LONDON</span></p>
<p class="noindent"><span class="bold">SHERIFF OF WILTSHIRE</span></p>
<p class="noindent1"><span class="bold">ELIZABETH</span>, Queen to King Edward IV</p>
<p class="noindent"><span class="bold">MARGARET</span>, widow to King Henry VI</p>
<p class="noindent"><span class="bold">DUCHESS OF YORK</span>, mother to King Edward IV, Clarence, and Gloster</p>
<p class="noindent"><span class="bold">LADY ANNE</span>, widow to Edward, Prince of Wales, son to King Henry VI; afterwards married to the Duke of Gloster</p>
<p class="noindent"><span class="bold">A YOUNG DAUGHTER OF CLARENCE</span></p>
<p class="noindent1">Lords, and other Attendants; two Gentlemen, a Pursuivant, Scrivener, Citizens, Murderers, Messengers, Ghosts, Soldiers, &amp;c.</p>
<p class="noindent1"><span class="bold">Scene: England</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Persons.vue?f0878db4